import { EditMode, MembershipType, Plan, PlanType, RenewalStrategy } from "../../../models";
import { PlanFormBase, PlanFormOutput } from "../PlanFormBase";
import { useData } from "../../../utils/useData";
import { LoadingSpinner } from "../../shared/LoadingSpinner";
import { isLoading } from "../../../utils/isLoading";
import { useMutatePlan } from "../../../hooks/useMutatePlan";
import { GiftTiersFields } from "./GiftTiersFields";
import { GiftingSettingsFields } from "./GiftingSettingsFields";
import { useCreatePlan } from "../../../hooks/useCreatePlan";
import { EmployerModuleType } from "../../../models/accounts/employerModuleType";

export const GiftForm = ({ gift, onClose }: { gift?: Plan, onClose: () => void }) => {
    const { plans, serviceSectors, accounts, membership } = useData();

    var openServiceSector = 
      serviceSectors.data!.items.find(
        x => x.status === "ACTIVE" && 
        x.restrictions.mccCodes.allow.length === 0 && 
        x.restrictions.mccCodes.block.length === 0 && 
        x.restrictions.providerNames.allow.length === 0 && 
        x.restrictions.providerNames.block.length === 0);

    const isPilot = membership.data?.type === MembershipType.PILOT;
    const editMode = gift == null ? EditMode.CREATE : EditMode.EDIT;

    const mutateGift = useMutatePlan({
      onSuccess: onClose,
      onError: (error) => console.log(error.message),
      successMessage: "Gift updated successfully"
    });

    const mutationCreatePlan = useCreatePlan(EmployerModuleType.GIFTING, {
      onSuccess: () => {
        onClose();
      },
      onError: (error: Error) => {
        console.log(error.message);
      }
    });

    const handleGiftSave = async (
        values: PlanFormOutput
      ) => {
        if (!gift) {
          await mutationCreatePlan.mutate({
            name: values.name,
            serviceSectorIds: [openServiceSector!.id],
            tiers: values.tiers,
            planType: PlanType.ONE_OFF,
            renewalOptions: values.renewalOptions,
            payments: {
              isEnabled: false
            },
            purchases: {
              isEnabled: true
            },
            management: {
              canAdHocTopUp: true
            }
          });
      
        } else {
          const updatedGift = {
            ...gift,
            name: values.name,
            tiers: values.tiers,
            controls: {
              ...gift.controls,
              serviceSectors: [openServiceSector!]
            }
          };
          await mutateGift.mutate(updatedGift);  
        }
      };
    

    if(isLoading([plans, accounts, serviceSectors])) return <LoadingSpinner />

    return (
        <PlanFormBase
            existingPlan={gift}
            moduleType={EmployerModuleType.GIFTING}
            isLoading={mutateGift.isLoading}
            serviceSectors={serviceSectors.data?.items ?? []}
            onClose={onClose}
            onSave={handleGiftSave}
            customDefaultValues={{ strategy: RenewalStrategy.EXPIRE }}
        >
            <GiftingSettingsFields isPilot={isPilot} editMode={editMode}/>
            <GiftTiersFields isPilot={isPilot} accounts={accounts.data!.items} editMode={editMode}/>
        </PlanFormBase>
    )
}
